import React from "react";
import BarekamText from "../../../../../../components/text";
import {MenuItem} from "@mui/material";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";

const OperationTypeFilter = (props: OperationTypeFilterProps) => {
    const {operation, onFilterChange} = props;

    return (
        <BarekamSelect
            variant={'outlined'}
            label={<Message messageKey={'operation'} sectionId={MessageSections.ORDERS}/>}
            value={operation === undefined ? 'all' : operation}
            type={"filter"}
            fullWidth
            required>
            <MenuItem onClick={() => onFilterChange(undefined)}
                            value={'all'}
                            key={'all'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>

            <MenuItem onClick={() => onFilterChange('insert')}
                            value={'insert'}
                            key={'insert'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"insert_operation"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>

            <MenuItem onClick={() => onFilterChange('update')}
                            value={'update'}
                            key={'update'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"update_operation"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>

            <MenuItem onClick={() => onFilterChange('delete')}
                            value={'delete'}
                            key={'delete'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"delete_operation"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>
        </BarekamSelect>
    );
};

export default OperationTypeFilter;

interface OperationTypeFilterProps {
    operation: string | undefined;
    onFilterChange: (operation: string | undefined) => void;
}
